export class BillingBucketDTO{
    public id!:number;
    public name!:string;
    public enabled!:boolean;
    public vendorId?:number;
    public added! : string;
    public edited! : string;
}